import { render, staticRenderFns } from "./InformationProcess.vue?vue&type=template&id=686de2bc"
import script from "./InformationProcess.vue?vue&type=script&lang=js"
export * from "./InformationProcess.vue?vue&type=script&lang=js"
import style0 from "./InformationProcess.vue?vue&type=style&index=0&id=686de2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports